export default __webpack_public_path__ + "static/media/Group13.6df4a6eb.png";